import { MaterialType, PanelConfig } from '../types';

/**
 * 재질별 패널 규격표
 * - thicknesses: 선택 가능한 두께 (mm)
 * - standardWidth: 표준 폭 = 제작 최대 폭 (자동 분할은 이 값으로 최대한 채움)
 * - halfWidth: 나머지가 minWidth 미만일 때 마지막 표준 패널을 대체하는 반절 크기
 * - minWidth: 최소 패널 폭 (이보다 작은 조각은 반절 전략으로 보정)
 *
 * 출처: 이전 시스템 DB(winexhnp) 코드표 — 재질 6종(우레탄판넬재질), 두께 75/100/125/150T,
 *       판넬벽체사이즈 900, 판넬최소사이즈 200 (전 두께 동일)
 */
export interface MaterialSpec {
  label: string;
  thicknesses: number[];
  standardWidth: number;
  halfWidth: number;
  minWidth: number;
}

export const MATERIAL_SPECS: Record<MaterialType, MaterialSpec> = {
  SP:   { label: 'SP (철판)', thicknesses: [75, 100, 125, 150], standardWidth: 900, halfWidth: 441, minWidth: 200 },
  PP:   { label: 'PP',        thicknesses: [75, 100, 125, 150], standardWidth: 900, halfWidth: 441, minWidth: 200 },
  GRAY: { label: '회색',      thicknesses: [75, 100, 125, 150], standardWidth: 900, halfWidth: 441, minWidth: 200 },
  IS:   { label: 'IS',        thicknesses: [75, 100, 125, 150], standardWidth: 900, halfWidth: 441, minWidth: 200 },
  SUS:  { label: 'SUS-단면',  thicknesses: [75, 100, 125, 150], standardWidth: 900, halfWidth: 441, minWidth: 200 },
  SUS2: { label: 'SUS-양면',  thicknesses: [75, 100, 125, 150], standardWidth: 900, halfWidth: 441, minWidth: 200 },
};

export const getMaterialSpec = (material: MaterialType): MaterialSpec =>
  MATERIAL_SPECS[material] ?? MATERIAL_SPECS.SP;

/** 기본 설정(DB/기본값)에 재질 규격을 덮어씀 — 표준 폭·최대 폭·반절·최소 분할 크기 */
export const applyMaterialSpec = (config: PanelConfig, material: MaterialType): PanelConfig => {
  const spec = getMaterialSpec(material);
  return {
    ...config,
    DEFAULT_SIZE: spec.standardWidth,
    MAX_SIZE: spec.standardWidth,
    HALF_SIZE: spec.halfWidth,
    SPLIT_MIN_SIZE: spec.minWidth,
  };
};
